import React, { FC, memo, ReactElement } from 'react';
import { Card } from 'react-bootstrap';
import BootstrapAvatar from '../BootstrapAvatar';
import { useChat } from '../../contexts/chat-context';
import { ChatHeadDto } from '../../../../shared/dtos/chat.dto';

type Props = {
  therapies: ChatHeadDto[];
  selectedTherapy: ChatHeadDto | null;
  handleSelectTherapy: (therapy: ChatHeadDto) => void;
};

const ChatHeadHorizontalComponent: FC<Props> = ({ therapies, selectedTherapy, handleSelectTherapy }: Props) => {
  const { unreadPatientIds } = useChat();

  const renderChatHead = (therapy: ChatHeadDto): ReactElement => {
    const isSelected: boolean = therapy.id === selectedTherapy?.id;

    return (
      <Card
        key={therapy.id}
        role="button"
        className={`flex-shrink-0 text-center ${isSelected ? 'bg-body-secondary' : ''}`}
        onClick={() => handleSelectTherapy(therapy)}>
        <Card.Body className="px-3 py-2">
          <BootstrapAvatar
            name={`${therapy.patientFirstName} ${therapy.patientLastName}`}
            size={40}
            color="#707089"
            className="rounded-circle"
            round={true}
          />
          <div className="d-flex justify-content-center align-items-center gap-1 small fw-semibold pt-2">
            {unreadPatientIds.has(therapy.patientId) ?
              <span className="rounded-circle flex-shrink-0" style={{ width: 8, height: 8, backgroundColor: '#ff695f' }} />
              : null}
            {therapy.patientFirstName.substring(0, 10)}
          </div>
        </Card.Body>
      </Card>
    );
  };

  if (therapies.length === 0) {
    return null;
  }

  return (
    <div className="d-flex flex-nowrap overflow-auto gap-2 p-2 border-bottom">
      {therapies.map(renderChatHead)}
    </div>
  );
};

export default memo(ChatHeadHorizontalComponent);
